import { CounterpartType, SettlementType, Ticket } from "./Entity";

export class PrivateFixedIncome extends Ticket {
  constructor() {
    super();
  }

  // Dados do Ativo
  settlementTypeId: SettlementType = null;
  SettlementType: CounterpartType = null;
  assetType: string = null;
  assetCode = null;
  expirationDate = null;
  amount: number = null;
  unitPrice: number = null;
  issueFee = null;
  isCetipVoice: boolean = null;
  propositionNumber: string = null;
  voiceNumber: string = null;

  operationValue = null;
  oldOperationValue: number = null;
  operationCode: string = null;

  issueDate: Date = null;
  acquisitionDate: Date = null;
  subscriptionDate: Date = null;
  settlementDate: Date = null;

  isSecondaryMarket: boolean;
  annotations = null;
  objectAction: string = null;

  index: string = null;
  indexPercent: number = null;
  issuer: string = null;
  indexBase: number = null;
  interestType: number = null;
  indexTax: number = null;

  // Dados Carteira/Fundo
  portfolioName = "";
  portfolioDocument = "";
  portfolioBank = null;
  portfolioBranch = null;
  portfolioAccount = "";
  portfolioCetipAccount = "";
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // Dados da Contraparte
  counterpartName = "";
  counterpartDocument = "";
  counterpartCetipAccount = "";
  counterpartType: number = null;
  counterPartBank = "";
  counterPartAccount = "";
  counterPartBranch = "";
  counterPartContact = "";
  isNewCounterpart: boolean;
  command = "";

  tempTicketId: any = null;

  transferStatusDescription: string = null;
}
